import dynamic from 'next/dynamic';
import { CreditCardInfoProps } from './CreditCardInfo.types';

export const CreditCardInfoMGP = dynamic<CreditCardInfoProps>(() =>
  import('./CreditCardInfo').then(module => module.CreditCardInfo)
);
